module.exports = __webpack_public_path__ + "img/sixcoin_flat_s.fe856234.png";